import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useIsMobileDimension } from '@beef/ui-kit';
// eslint-disable-next-line import/no-unresolved
import { Button, PhoneInput, Title } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { CaptchaInput } from "../../../../components/Captcha/Carnica";
import { FormLayout, LogoButton } from "../../../../_shared/components";
import { BackButton } from "../../../../_shared/components/HeaderButtons/BackButton";
import { ModalLayout } from "../../../../_shared/components/ModalLayout";
import { PAYMENT_SUBJECT_CONFIG } from "../../../../constants/payment";
import { findFirst } from "../../../../utils/arrays";
import { unformatPhone } from "../../../../utils/formatters";
import { withControlAnalytics } from "../../../../utils/withControlAnalytics";
import { SberPayBinding } from "../../types";
import { LegalBlock } from "../../components/LegalBlock";
import { Validation } from "../../components/Validation";
import { onButtonPressAnalyticsHandler, onPhoneInputAnalyticsHandler } from "../analytics";
import { CAPTCHA_ERROR } from "../constants";
import styles from "./styles.pcss";
import { CAPTCHA_LENGTH } from "./constants";
var EnhancedInput = withControlAnalytics('onBlur', onPhoneInputAnalyticsHandler)(PhoneInput);
var EnhancedButton = withControlAnalytics('onClick', onButtonPressAnalyticsHandler)(Button);
var cn = classNames.bind(styles);
var PaymentProcess = function PaymentProcess(_ref) {
  var _currentStep$buttonTe;
  var ctn = _ref.ctn,
    isLoading = _ref.isLoading,
    stepsData = _ref.stepsData,
    paymentSubject = _ref.paymentSubject,
    sendSberPaymentRequest = _ref.sendSberPaymentRequest,
    onClose = _ref.onClose,
    initialCtn = _ref.initialCtn,
    hasCaptchaError = _ref.hasCaptchaError,
    setHasCaptchaError = _ref.setHasCaptchaError,
    hasCaptcha = _ref.hasCaptcha,
    captchaTexts = _ref.captchaTexts;
  var _React$useState = React.useState(initialCtn || ''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    fromCtn = _React$useState2[0],
    setFromCtn = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    fromCtnError = _React$useState4[0],
    setFromCtnError = _React$useState4[1];
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    captcha = _useState2[0],
    setCaptcha = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    step = _useState4[0],
    setStep = _useState4[1];
  var isMobile = useIsMobileDimension();
  useEffect(function () {
    if (captcha.length >= CAPTCHA_LENGTH) {
      handleClick();
    }
  }, [captcha]);
  var handleClick = React.useCallback(function () {
    sendSberPaymentRequest(unformatPhone(ctn), unformatPhone(fromCtn), captcha);
  }, [ctn, fromCtn, captcha]);
  var steps = [(step === 0 || !hasCaptcha) && _objectSpread(_objectSpread({}, stepsData), {}, {
    onBackButtonClick: onClose,
    onConfirmClick: function onConfirmClick() {
      return setStep(1);
    }
  }), step === 1 && hasCaptcha && _objectSpread(_objectSpread({}, captchaTexts), {}, {
    onBackButtonClick: function onBackButtonClick() {
      return setStep(0);
    },
    onConfirmClick: handleClick
  })];
  var currentStep = steps.find(Boolean);
  var captchaErrorMessage = hasCaptchaError ? CAPTCHA_ERROR : undefined;
  var onCaptchaChangeHandler = function onCaptchaChangeHandler(value) {
    setCaptcha(value);
    setHasCaptchaError(false);
  };
  var handleSetFromCtn = React.useCallback(function (validateCtn) {
    return function (value) {
      validateCtn();
      setFromCtn(value);
    };
  }, [paymentSubject]);
  var isDisabled = !!fromCtnError || hasCaptcha && step === 1 && (!captcha || !!captchaErrorMessage);
  return /*#__PURE__*/React.createElement(ModalLayout, {
    className: cn('wrapper')
  }, /*#__PURE__*/React.createElement(ModalLayout.Header, null, /*#__PURE__*/React.createElement(BackButton, {
    onClick: steps[step].onBackButtonClick
  }), /*#__PURE__*/React.createElement(LogoButton, null)), /*#__PURE__*/React.createElement(ModalLayout.Content, null, /*#__PURE__*/React.createElement(Title, {
    className: cn('title', {
      'title--left': step === 1 || isMobile
    }),
    size: findFirst([isMobile && 'm', 'l']),
    subTitle: currentStep.description,
    title: currentStep.title
  }), /*#__PURE__*/React.createElement(FormLayout, null, /*#__PURE__*/React.createElement(FormLayout.Input, null, steps[0] && /*#__PURE__*/React.createElement(Validation, {
    fromCtn: fromCtn,
    setFromCtnError: setFromCtnError
  }, function (_ref2) {
    var validateCtn = _ref2.validateCtn;
    validateCtn();
    return /*#__PURE__*/React.createElement(EnhancedInput, {
      autoFocus: true,
      className: cn('input-field'),
      errorMessage: fromCtnError,
      label: PAYMENT_SUBJECT_CONFIG.cellphone.title.toLowerCase() // TODO: Move to content
      ,
      maskSettings: {
        mask: ' ',
        format: PAYMENT_SUBJECT_CONFIG.cellphone.mask
      },
      noErrorIndent: true,
      onBlur: validateCtn,
      onChange: handleSetFromCtn(validateCtn),
      onClear: function onClear() {
        return handleSetFromCtn(validateCtn)('');
      },
      placeholder: PAYMENT_SUBJECT_CONFIG.cellphone.placeholder.toLowerCase() // TODO: Move to content
      ,
      type: "text",
      value: fromCtn,
      wrapperProps: {
        width: 'default',
        className: cn('input')
      }
    });
  }), steps[1] && /*#__PURE__*/React.createElement(CaptchaInput, {
    disabled: isLoading,
    error: captchaErrorMessage,
    label: PAYMENT_SUBJECT_CONFIG.captcha.title.toLowerCase() // TODO: Move to content
    ,
    onChange: onCaptchaChangeHandler,
    placeholder: PAYMENT_SUBJECT_CONFIG.captcha.placeholder.toLowerCase() // TODO: Move to content
    ,
    value: captcha
  })), /*#__PURE__*/React.createElement(FormLayout.Buttons, null, /*#__PURE__*/React.createElement(LegalBlock, {
    text: stepsData.userAgreement
  }, /*#__PURE__*/React.createElement(EnhancedButton, {
    disabled: isDisabled,
    loading: isLoading,
    onClick: currentStep.onConfirmClick,
    size: "l",
    width: "full"
  }, (_currentStep$buttonTe = currentStep.buttonText) !== null && _currentStep$buttonTe !== void 0 ? _currentStep$buttonTe : ''))))));
};
PaymentProcess.propTypes = process.env.NODE_ENV !== "production" ? {
  ctn: PropTypes.string,
  initialCtn: PropTypes.string,
  isLoading: PropTypes.bool,
  paymentSubject: PropTypes.oneOf([PAYMENT_SUBJECT_CONFIG.cellphone.id, PAYMENT_SUBJECT_CONFIG.internet.id]),
  stepsData: SberPayBinding,
  sendSberPaymentRequest: PropTypes.func,
  hasCaptcha: PropTypes.bool
} : {};
export default PaymentProcess;